import filterTypeCheckers from '../../FilterPlateForm/filterTypeCheckers';
import toSentenceCase from '../../../services/toSentenceCase';
import getWildcardFilterMode from './getWildcardFilterMode';

export const getDrillDownDescription = (
  drillDown: FixedFilter,
  fieldName: string,
): string => {
  if (filterTypeCheckers.isTextFilter(drillDown)) {
    const base = (() => {
      if (drillDown.keywordsExists !== undefined) {
        if (!drillDown.keywordsExists) {
          return `${['Blanks', ...(drillDown.keywordValues || [])].join(', ')}`;
        } else {
          return `${(drillDown.keywordValues || []).join(', ')}`;
        }
      } else {
        return `${(drillDown.keywordValues || []).join(', ')}`;
      }
    })();

    if (drillDown.isExclude) {
      return `${fieldName}s excluding ${base}`;
    } else {
      return `${fieldName}s are ${base}`;
    }
  } else if (filterTypeCheckers.isWildcardFilter(drillDown)) {
    const base = drillDown.wildcardFilter.pattern;

    if (drillDown.wildcardFilter.exclude) {
      return `${fieldName}s excluding ${base}`;
    } else {
      return `${fieldName}s are ${base}`;
    }
  } else if (filterTypeCheckers.isNumberFilter(drillDown)) {
    if (drillDown.rangeValue) {
      if (drillDown.rangeValue.valueB) {
        return `${fieldName} ${drillDown.rangeValue.operator} ${drillDown.rangeValue.valueA} and ${drillDown.rangeValue.valueB}`;
      }
      return `${fieldName} ${drillDown.rangeValue.operator} ${drillDown.rangeValue.valueA}`;
    }
    if (drillDown.exists !== undefined) {
      if (drillDown.exists) {
        return `${fieldName} has some value`;
      } else {
        return `${fieldName} has no value`;
      }
    }
  } else if (filterTypeCheckers.isBooleanFilter(drillDown)) {
    if (
      drillDown.booleanValue === undefined &&
      drillDown.exists !== undefined
    ) {
      if (drillDown.exists === false) {
        return `${fieldName} has no value`;
      }
    } else {
      return `${fieldName} is ${drillDown.booleanValue}`;
    }
  } else if (filterTypeCheckers.isDateFilter(drillDown)) {
    const { dateRangeValues, exists } = drillDown;
    const mustExist = exists !== undefined && exists;
    const mustNotExist = exists !== undefined && !exists;
    if (dateRangeValues) {
      return `${fieldName}s are ${(drillDown.dateRangeValues || [])
        .map((d) => d.label)
        .join(', ')}`;
    } else if (mustExist) {
      return `${fieldName} must exist`;
    } else if (mustNotExist) {
      return `${fieldName} must not exist`;
    } else {
      return `${fieldName} is ...`;
    }
  }

  return '';
};

export const getFieldValue = (drillDown: FixedFilter): string => {
  if (filterTypeCheckers.isTextFilter(drillDown)) {
    const base = (() => {
      if (drillDown.keywordsExists !== undefined) {
        if (!drillDown.keywordsExists) {
          return `${['Blanks', ...(drillDown.keywordValues || [])].join(', ')}`;
        } else {
          return `${(drillDown.keywordValues || []).join(', ')}`;
        }
      } else {
        return `${(drillDown.keywordValues || []).join(', ')}`;
      }
    })();
    if (drillDown.isExclude) {
      return `Exclude: ${base}`;
    } else {
      return base;
    }
  } else if (filterTypeCheckers.isWildcardFilter(drillDown)) {
    const mode = getWildcardFilterMode(drillDown);
    const pattern = drillDown.wildcardFilter.pattern.replaceAll('*', '');
    if (mode) {
      return `${toSentenceCase(mode, true)} ${pattern}`;
    }
    return pattern;
  } else if (filterTypeCheckers.isDateFilter(drillDown)) {
    const { dateRangeValues, exists } = drillDown;
    const mustExist = exists !== undefined && exists;
    const mustNotExist = exists !== undefined && !exists;
    if (dateRangeValues) {
      return `${(drillDown.dateRangeValues || [])
        .map((d) => d.label)
        .join(', ')}`;
    } else if (mustExist) {
      return `must exist`;
    } else if (mustNotExist) {
      return `must not exist`;
    } else {
      return `...`;
    }
  } else if (filterTypeCheckers.isNumberFilter(drillDown)) {
    return getDrillDownDescription(drillDown, '');
  } else if (filterTypeCheckers.isBooleanFilter(drillDown)) {
    return getDrillDownDescription(drillDown, '').replace(` is `, '');
  }

  return '';
};
